import { addParamsToUrl } from 'utils';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

import { CourseSubmissionPdfRequest } from './types';

export const downloadCourseSubmissionPdf = ({
  id,
  timezone,
}: CourseSubmissionPdfRequest) =>
  apiLoaderInstance.get(
    addParamsToUrl(URL.COURSE_SUBMISSIONS_CERTIFICATE_PDF.replace(':id', id), {
      timezone,
    }),
    { responseType: 'blob' }
  );
